"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalWrapper = exports.ModalOverlay = exports.ModalHeader = exports.ModalFooter = exports.ModalContent = exports.ModalBody = void 0;

var _react = _interopRequireDefault(require("react"));

var _tailwindMerge = require("tailwind-merge");

var _excluded = ["isOpen", "onClose", "isCentered", "closeOnOverlayClick", "closeOnEsc", "scrollBehavior", "noStyles", "size", "className", "children", "onClick"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var wrapEvent = function wrapEvent(theirHandler, ourHandler) {
  return function (event) {
    if (theirHandler) {
      theirHandler(event);
    }

    if (!event.defaultPrevented) {
      return ourHandler(event);
    }
  };
};

var ModalWrapper = function ModalWrapper(props) {
  var isOpen = props.isOpen,
      onClose = props.onClose,
      _props$isCentered = props.isCentered,
      isCentered = _props$isCentered === void 0 ? true : _props$isCentered,
      _props$closeOnOverlay = props.closeOnOverlayClick,
      closeOnOverlayClick = _props$closeOnOverlay === void 0 ? true : _props$closeOnOverlay,
      _props$closeOnEsc = props.closeOnEsc,
      closeOnEsc = _props$closeOnEsc === void 0 ? true : _props$closeOnEsc,
      _props$scrollBehavior = props.scrollBehavior,
      scrollBehavior = _props$scrollBehavior === void 0 ? 'inside' : _props$scrollBehavior,
      noStyles = props.noStyles,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      className = props.className,
      children = props.children,
      onClick = props.onClick,
      restProps = _objectWithoutProperties(props, _excluded);

  var wrapperClassName = '';
  var contentClassName = '';

  if (isCentered) {
    wrapperClassName = 'flex items-center justify-center';
  } else {
    contentClassName = 'top-[50%] mx-auto';
  }

  if (scrollBehavior === 'inside') {
    wrapperClassName = "".concat(wrapperClassName, " max-h-[calc(100vh - 7.5rem)] overflow-hidden top-[20vh]");
    contentClassName = "".concat(contentClassName, " h-full top-0");
  }

  if (scrollBehavior === 'outside') {
    wrapperClassName = "".concat(wrapperClassName, " overflow-y-auto overflow-x-hidden");
    contentClassName = "".concat(contentClassName, " my-[3.75rem] top-0");
  }

  if (noStyles) {
    wrapperClassName = '';
    contentClassName = '';
  }

  var widths = {
    sm: '200px',
    md: '600px',
    lg: '800px',
    xl: '90vw'
  };
  return isOpen && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _tailwindMerge.twMerge)("fixed left-0 top-0 w-screen h-screen z-[999999]", wrapperClassName),
    onClick: function onClick(event) {
      event.stopPropagation();

      if (closeOnOverlayClick) {
        onClose(event, 'clickedOverlay');
      }
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Escape') {
        event.stopPropagation();

        if (closeOnEsc) {
          onClose(event, 'pressedEscape');
        }
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("section", _extends({
    className: (0, _tailwindMerge.twMerge)('relative flex flex-col z-modal outline-0 w-full', contentClassName),
    role: "dialog",
    "aria-modal": "true",
    tabIndex: -1,
    style: {
      maxWidth: widths[size]
    },
    onClick: wrapEvent(onClick, function (event) {
      return event.stopPropagation();
    })
  }, restProps), children));
};

exports.ModalWrapper = ModalWrapper;

var ModalOverlay = function ModalOverlay(props) {
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: 'fixed z-[1000] bottom-0 top-0 left-0 right-0 overflow-y-auto bg-[rgba(16,22,26,0.7)] content__image--modal-overlay'
  }, props));
};

exports.ModalOverlay = ModalOverlay;

var ModalContent = function ModalContent(props) {
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: 'w-full relative flex flex-col bg-brand-white max-w-[80vw] p-[1rem] cursor-zoom-out fixed z-[2000] content__image--modal-content'
  }, props));
};

exports.ModalContent = ModalContent;

var ModalHeader = function ModalHeader(props) {
  return /*#__PURE__*/_react["default"].createElement("header", _extends({
    className: 'px-6 py-4 relative text-xl font-[600] content__image--modal-header'
  }, props));
};

exports.ModalHeader = ModalHeader;

var ModalFooter = function ModalFooter(props) {
  return /*#__PURE__*/_react["default"].createElement("footer", _extends({
    className: 'flex px-6 pt-[1rem] pb-0 justify-center flex-col sm:flex-row border-t border-t-brand-grey text-center font-body pt-[1rem] pb-0 content__image--modal-footer'
  }, props));
};

exports.ModalFooter = ModalFooter;

var ModalBody = function ModalBody(props) {
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: 'p-0 flex-[1] content__image--modal-body'
  }, props));
};

exports.ModalBody = ModalBody;